import { render, staticRenderFns } from "./add-mj-key-modal.vue?vue&type=template&id=12c4e1b8&lang=pug&"
import script from "./add-mj-key-modal.vue?vue&type=script&lang=js&"
export * from "./add-mj-key-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-mj-key-modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports